export const getTimeFormatFromCode = (timeFormatCode: string): string => {
  return timeFormatCode.includes('H24') ? 'HH:mm' : 'hh:mm A';
};
